<template>
  <PlaceholderForm v-if="loading" />
  <template v-else>
    <div class="d-flex gap-3">
      <div class="d-flex flex-column flex-grow-1 gap-3">
        <div class="card">
          <div class="card-header">
            <slot name="header" />
          </div>
          <article class="card-body">
            <slot name="body" />
          </article>
        </div>
        <slot name="footer" />
      </div>
      <slot name="aside" />
    </div>
  </template>
</template>
<script lang="ts" setup>
defineProps<{
  loading: boolean;
}>();
</script>
<style lang="scss" scoped>
:deep(.row) {
  margin-bottom: 1rem;
}
</style>
